<template>
  <div class="panel panel-default">
    <loading-spinner v-if="loading"></loading-spinner>

    <div v-else class="panel-body text-center" style="padding: 18px 0;">
      <span style="font-size: 48px; line-height:48px;">{{ count | number }}</span>

      <br>

      <span class="text-muted" style="font-size: 14px; line-height:14px;">Tasks</span>
    </div>
  </div>
</template>

<script>
import Load from '@/mixins/Load'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'

export default {
  components: {LoadingSpinner},

  mixins: [Load],

  data() {
    return {
      tasks: null
    }
  },

  mounted() {
    this.load({tasks: '/api/v2/tasks'})
  },

  computed: {
    count() {
      return this.tasks.data.length
    }
  }
}
</script>
